import type { ReactNode } from "react";
import { useLayout } from "./layout";

/**
 * The page's one action on a phone (`.k-bar`): docked and solid, full width, on top of the tab bar. It draws nothing on
 * a tablet: there the action goes in the page's card or pane head. It steps aside while the keyboard is up.
 */
export function DockedBar({ children }: { children: ReactNode }) {
  if (useLayout() !== "phone") return null;
  return <div className="k-bar">{children}</div>;
}
